import React, { useState } from 'react';
import {
  Box,
  Grid,
  Card,
  Stack,
  Chip,
  Tabs,
  Tab,
  Button,
  Typography,
  IconButton,
} from '@mui/material';

import { LuCircleUserRound, LuPencil, LuGift, LuUsersRound } from 'react-icons/lu';
import { MdFiberNew, MdMoreVert, MdOutlineDiscount } from 'react-icons/md';
import { IoWalletOutline, IoSettingsOutline } from 'react-icons/io5';
import { TbCancel } from "react-icons/tb";
import { CiPause1 } from 'react-icons/ci';
import IncludedServicesTab from './IncludedServicesTab';
import OverviewBundleTab from './OverviewBundleTab';
import RedemptionsBundleTab from './RedemptionsBundleTab';
import BudgetUsageBundleTab from './BudgetUsageBundleTab';
import ActivityLogBundleTab from './ActivityLogBundleTab';
import { GrPieChart } from 'react-icons/gr';


const mockBundle = {
  code: '10K Maintenance Bundle',
  id: 'BUN-00012',
  status: 'Active',
  stats: {
    totalBundlesSold: 1248,
    totalRevenue: 1497600,
    remainingBudget: 313500,
    usageRate: 24.96,
    bundleBuyers: 980,
  },
  basicInfo: {
    triggerType: 'Purchased via App',
    originalValue: 1600,
    bundlePrice: 1200,
    totalSavings: 400,
    totalSavingsPercent: 25,
    validityPeriod: 180,
    usageLimit: '1 per customer',
    totalBundlesLimit: 1000,
    remainingBundles: 650,
    remainingBundlesPercent: 65.0,
    status: 'Active',
  },
  validity: {
    startDate: 'May 15, 2026 12:00 am',
    endDate: 'May 31, 2026 11:59 am',
    days: 16,
    timeRestriction: 'No',
  },
  fundingLiability: {
    fundingSource: 'ESTBN',
    estbnShare: 100,
    providerShare: 0,
    totalCommittedBudget: 500000,
    totalRedeemedCost: 186500,
    remainingBudget: 313500,
    remainingBudgetPercent: 62.4,
  },
  eligibilityRules: {
    eligibleCustomers: 'All Customers',
    customerTiers: 'All Tiers',
    bundleScope: 'Package Services',
    excludedItems: 'Parts Only Orders',
    stacking: 'Non-stackable',
    redemptionType: 'Single / Multiple Visits',
  },
  quickInsights: [
    { type: 'budget', text: '62.4% of total bundles have been sold' },
    { type: 'users', text: '980 unique customers purchased this bundle' },
    { type: 'discount', text: 'Average savings per customer: 400 EGP' },
  ],
  redemptionTrend: [
    { date: 'Apr 22', redemptions: 180 },
    { date: 'Apr 25', redemptions: 340 },
    { date: 'Apr 29', redemptions: 560 },
    { date: 'May 02', redemptions: 400 },
    { date: 'May 06', redemptions: 230 },
    { date: 'May 09', redemptions: 260 },
    { date: 'May 13', redemptions: 300 },
    { date: 'May 16', redemptions: 210 },
    { date: 'May 20', redemptions: 150 },
  ],
  includedServices: {
    totalIncludedServices: 4,
    originalTotalPrice: 1600,
    bundlePrice: 1200,
    totalSavings: 400,
    totalSavingsPercent: 25,
  },
  servicesBreakdown: [
    { id: 'SVC-1', name: 'Synthetic Oil Change (4L)', category: 'Maintenance', originalPrice: 800, bundlePrice: 600, redemptionLimit: '1 Visit', status: 'Active' },
    { id: 'SVC-2', name: 'Free Oil Filter', category: 'Maintenance', originalPrice: 150, bundlePrice: 0, redemptionLimit: '1 Visit', status: 'Active' },
    { id: 'SVC-3', name: 'Comprehensive Inspection', category: 'Maintenance', originalPrice: 450, bundlePrice: 350, redemptionLimit: '1 Visit', status: 'Active' },
    { id: 'SVC-4', name: 'Tire Rotation & Balancing', category: 'Maintenance', originalPrice: 250, bundlePrice: 200, redemptionLimit: '2 Visits', status: 'Active' },
  ],
  redemptionRules: {
    validityPeriod: 180,
    serviceUsage: 'Multi-visit allowed',
    locations: 'All Authorized Stations',
  },
  costBreakdown: {
    total: 400,
    segments: [
      { label: 'Parts Savings', value: 150, percent: 37.5, color: '#3FBEAC' },
      { label: 'Labor Savings', value: 250, percent: 62.5, color: '#FEB91E' },
    ],
  },
  redemptionSummary: {
    totalRedemption: 1284,
    bundleOwners: 982,
    avgSavingsPerRedemption: 131,
    totalDiscountedAmount: 15000,
    totalSalesGenerated: 120000,
  },
  redemptionOverTime: {
    granularity: 'Daily',
    dateRangeLabel: 'Mar 10, 2025 - May 31, 2025',
    data: [
      { date: 'Mar 10', redemptions: 20 },
      { date: 'Mar 17', redemptions: 65 },
      { date: 'Mar 24', redemptions: 110 },
      { date: 'Mar 31', redemptions: 130 },
      { date: 'Apr 07', redemptions: 165 },
      { date: 'Apr 21', redemptions: 165 },
      { date: 'Apr 28', redemptions: 115 },
      { date: 'May 05', redemptions: 105 },
      { date: 'May 12', redemptions: 145 },
      { date: 'May 19', redemptions: 190 },
      { date: 'May 26', redemptions: 175 },
      { date: 'May 31', redemptions: 205 },
    ],
  },
  recentRedemptions: [
    { id: 'RED-1248', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', redeemedService: 'Synthetic Oil Change (4L)', serviceSavings: 150, status: 'Completed' },
    { id: 'RED-1247', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', redeemedService: 'Free Oil Filter', serviceSavings: 100, status: 'Completed' },
    { id: 'RED-1246', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', redeemedService: 'Comprehensive Inspection', serviceSavings: 100, status: 'Completed' },
    { id: 'RED-1245', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', redeemedService: 'Tire Rotation & Balancing', serviceSavings: 50, status: 'Completed' },
    { id: 'RED-1244', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', redeemedService: 'Synthetic Oil Change (4L)', serviceSavings: 150, status: 'Completed' },
    { id: 'RED-1243', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', redeemedService: 'Free Oil Filter', serviceSavings: 100, status: 'Completed' },
    { id: 'RED-1242', user: 'Mona Salah', dateTime: 'May 18, 2025 - 02:15 pm', orderId: 'ORD-3549', redeemedService: 'Comprehensive Inspection', serviceSavings: 100, status: 'Completed' },
  ],
  redemptionByStatus: {
    total: 256,
    segments: [
      { label: 'Completed', value: 1152, percent: 89.6, color: '#3FBEAC' },
      { label: 'Failed', value: 64, percent: 5.0, color: '#FEB91E' },
      { label: 'Expired', value: 48, percent: 3.7, color: '#696969' },
      { label: 'Cancelled', value: 20, percent: 1.6, color: '#A80101' },
    ],
  },
  redemptionByChannel: [
    { label: 'Mobile App', value: 912, percent: 71.0 },
    { label: 'Website', value: 232, percent: 18.1 },
    { label: 'Call Center', value: 96, percent: 7.5 },
    { label: 'POS', value: 44, percent: 3.4 },
  ],
  userBreakdown: [
    { label: 'New Customers', percent: 65, color: '#FEB91E', icon: <MdFiberNew size={20} color={"#FEB91E"} /> },
    { label: 'Returning Customers', percent: 35, color: '#3E9FF6', icon: <LuCircleUserRound size={20} color={"#3FBEAC"} /> },
  ],
  redemptionInsights: [
    'Redemption rate is 12% higher than average for similar bundles.',
    'Mobile App is the top channel with 71% of total redemptions.',
    'Synthetic Oil Change is the most redeemed service in this bundle.',
    'Most redemptions occur on weekends.',
  ],
  budgetReview: {
    totalBudget: 500000,
    consumedBudget: 186500,
    remainingBudget: 313500,
    utilization: 37.3,
  },
  budgetConsumption: {
    used: 186500,
    total: 500000,
  },
  fundingAllocation: {
    total: 500000,
    platform: 400000,
    provider: 100000,
  },
  budgetRedemptionSummary: {
    totalBundlesLimit: 1000,
    remainingBundles: 650,
    avgSavingsPerBundle: 400,
    usageRate: 29.0,
  },
  budgetHistory: [
    { date: 'Apr 21', amount: 2000 },
    { date: 'Apr 23', amount: 6000 },
    { date: 'Apr 25', amount: 10000 },
    { date: 'Apr 27', amount: 14000 },
    { date: 'Apr 29', amount: 17000 },
    { date: 'May 01', amount: 20000 },
    { date: 'May 03', amount: 22000 },
    { date: 'May 05', amount: 24000 },
    { date: 'May 07', amount: 24500 },
    { date: 'May 09', amount: 27000 },
    { date: 'May 11', amount: 29000 },
    { date: 'May 13', amount: 33000 },
    { date: 'May 15', amount: 37000 },
    { date: 'May 17', amount: 39000 },
    { date: 'May 19', amount: 45000 },
  ],
  budgetHealth: {
    status: 'Healthy',
    message: 'Your budget is on track',
  },
  fundingSplit: {
    platform: 500000,
    platformPercent: 80,
    provider: 400000,
    providerPercent: 20,
    total: 500000,
  },
  budgetRules: [
    { label: 'Budget Type', value: 'Fixed Budget' },
    { label: 'Budget Limit', value: '500,000 EGP' },
    { label: 'Auto Pause', value: 'Enabled', isChip: true },
    { label: 'Pause Threshold', value: '95%' },
    { label: 'Allow Over Budget', value: 'No' },
    { label: 'Max Bundles Per Customer', value: '1 Bundle per customer' },
  ],
  budgetAlerts: {
    hasActiveAlerts: false,
    notifications: ['You will be notified when budget utilization reaches 85%'],
  },
  activityLog: {
    dateRangeLabel: 'Mar 10, 2025 - May 31, 2025',
    pagination: {
      shown: 1,
      pages: 8,
      total: 48,
      current: 1,
      pageButtons: [1, 2, 3, '…', 10],
    },
    entries: [
      {
        id: 'ACT-1',
        date: 'May 31, 2025',
        time: '10:45 am',
        user: 'Sarah Ahmed',
        role: 'Admin',
        action: 'Created Bundle',
        category: 'Bundle Creation',
        detailLabel: 'Initial Value:',
        detailValue: '500,000 EGP',
        ipAddress: '197.168.1.12',
      },
      {
        id: 'ACT-2',
        date: 'May 31, 2025',
        time: '09:30 am',
        user: 'Sarah Ahmed',
        role: 'Admin',
        action: 'Updated Budget Limit',
        category: 'Bundle Creation',
        detailLabel: 'Changed from:',
        detailValue: '300,000 EGP to 500,000 EGP',
        ipAddress: '197.168.1.12',
      },
      {
        id: 'ACT-3',
        date: 'May 30, 2025',
        time: '04:15 pm',
        user: 'Omar Hassan',
        role: 'Manager',
        action: 'Assigned to Provider',
        category: 'Bundle Creation',
        detailLabel: 'Provider:',
        detailValue: 'Provider Co.',
        ipAddress: '197.168.1.15',
      },
      {
        id: 'ACT-4',
        date: 'May 29, 2025',
        time: '02:20 pm',
        user: 'Ahmed Ali',
        role: 'Supervisor',
        action: 'Auto Pause Triggered',
        category: 'Bundle Creation',
        detailLabel: 'Threshold reached:',
        detailValue: '(95%)',
        ipAddress: '197.168.1.21',
      },
      {
        id: 'ACT-5',
        date: 'May 27, 2025',
        time: '11:05 am',
        user: 'Sarah Ahmed',
        role: 'Admin',
        action: 'Resumed Budget',
        category: 'Bundle Creation',
        detailLabel: 'Budget resumed',
        detailValue: 'manually',
        ipAddress: '197.168.1.12',
      },
      {
        id: 'ACT-6',
        date: 'May 26, 2025',
        time: '06:40 pm',
        user: 'System',
        role: 'System',
        action: 'Redemption Processed',
        category: 'Bundle Creation',
        detailLabel: 'Redemption ID: #RED-9821',
        detailValue: 'Amount: 150 EGP',
        ipAddress: '10.0.0.5',
      },
    ],
  },
  activitySummary: {
    dateRangeLabel: 'May 20 - May 31, 2025',
    totalActivities: 48,
    budgetChanges: 12,
    ruleUpdates: 9,
    redemptions: 27,
  },
  topUsers: [
    { name: 'Sarah Ahmed', role: 'Admin', activities: 18, initials: 'SA', avatarBg: '#F6E9FC', color: "#7E1BAD" },
    { name: 'Omar Hassan', role: 'Manager', activities: 12, initials: 'OH', avatarBg: '#F4F8F0', color: "#8CB369" },
    { name: 'Ahmed Ali', role: 'Supervisor', activities: 8, initials: 'AA', avatarBg: '#F0F8FF', color: "#3E9FF6" },
    { name: 'System', role: 'System', activities: 10, initials: '', avatarBg: '#F8F8F8', icon: <IoSettingsOutline size={16} color="#696969" /> },
  ],
};

const ACCENT = '#3FBEAC';
const BORDER = '#E8E8E8';

const currencyEGP = (n) => `${Number(n).toLocaleString()} EGP`;



const StatCard = ({ icon, iconColor, iconBg, label, value }) => (
  <Card variant="outlined" sx={{ borderRadius: 3, p: 2, borderColor: BORDER, height: '100%' }}>
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: iconBg,
          color: iconColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Typography variant="body2" color="#535353">
        {label}
      </Typography>
    </Stack>
    <Typography variant="h6" fontWeight={700} sx={{ mt: 1.5 }}>
      {value}
    </Typography>
  </Card>
);

const TABS = ['Overview', 'Included Services', 'Redemptions', 'Budget & Usage', 'Activity Log'];

const BundleDetails = ({ data = mockBundle }) => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ m: { xs: 2, md: 4 } }}>

      {/* Header */}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'flex-start' }}
        spacing={2}
        sx={{ mb: 3, flexWrap: 'wrap' }}
      >
        <Box>
          <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
            <Typography variant="h5" fontWeight={700}>
              {data.code}
            </Typography>
            <Chip
              size="small"
              label={data.status}
              sx={{ bgcolor: '#ECF9F7', fontWeight: 600, px: 1 }}
            />
          </Stack>
          <Typography variant="body2" color="#535353" sx={{ mt: 0.5 }}>
            {data.id}
          </Typography>
        </Box>

        <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap', gap: 1.5, rowGap: 1.5 }}>
          <Button
            variant="outlined"
            startIcon={<LuPencil size={18} />}
            sx={{ textTransform: 'none', color: '#000000', gap: .4, borderColor: "#E8E8E8" }}
          >
            Edit
          </Button>
          <Button
            variant="outlined"
            startIcon={<CiPause1 size={18} />}
            sx={{ textTransform: 'none', color: '#000000', gap: .4, borderColor: "#E8E8E8" }}
          >
            Pause
          </Button>
          <Button
            variant="outlined"
            startIcon={<TbCancel size={18} />}
            sx={{ textTransform: 'none', color: '#A80101', gap: .4, borderColor: "#E8E8E8" }}
          >
            Disable
          </Button>
          <IconButton sx={{ border: '1px solid #E0E3E8', borderRadius: 1.5 }}>
            <MdMoreVert size={18} />
          </IconButton>
        </Stack>
      </Stack>

      {/* Stat cards */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<LuGift size={25} />}
            iconColor="#FFFFFF"
            iconBg="#04B22E"
            label="Total Bundles Sold"
            value={data.stats.totalBundlesSold.toLocaleString()}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<MdOutlineDiscount size={25} />}
            iconColor="#FFFFFF"
            iconBg="#7E1BAD"
            label="Total Revenue"
            value={currencyEGP(data.stats.totalRevenue)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<IoWalletOutline size={25} />}
            iconColor="#FFFFFF"
            iconBg="#000000"
            label="Remaining Budget"
            value={currencyEGP(data.stats.remainingBudget)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<GrPieChart size={25} />}
            iconColor="#FFFFFF"
            iconBg="#3E9FF6"
            label="Usage Rate"
            value={`${data.stats.usageRate}%`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <StatCard
            icon={<LuUsersRound size={25} />}
            iconColor="#FFFFFF"
            iconBg="#696969"
            label="Bundle Buyers"
            value={data.stats.bundleBuyers.toLocaleString()}
          />
        </Grid>
      </Grid>

      {/* Tabs */}
      <Box className="custom-tab-style">
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            mb: 3,
            minHeight: 40,
            borderBottom: `1px solid ${BORDER}`,
            '& .MuiTabs-indicator': { backgroundColor: ACCENT, height: 2.5 },
          }}
        >
          {TABS.map((t) => (
            <Tab
              key={t}
              label={t}
              sx={{
                textTransform: 'none',
                minHeight: 40,
                color: '#535353',
                '&.Mui-selected': { color: "#000000" },
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Tab content */}
      {tab === 0 && <OverviewBundleTab data={data} />}
      {tab === 1 && <IncludedServicesTab data={data} />}
      {tab === 2 && <RedemptionsBundleTab data={data} />}
      {tab === 3 && <BudgetUsageBundleTab data={data} />}
      {tab === 4 && <ActivityLogBundleTab data={data} />}
    </Box>
  );
};

export default BundleDetails;